import { libraries } from "@ember/-internals/metal";
import DmpConnect from "parog-web/cnam-adapters/dmpconnect-js/dmp-connect";

/**
 * This initializer is used to set `libraries`.
 *
 * `libraries` is used by Ember Inspector (and probably other things) to display
 * which library is used by the app and which version.
 */
export function initialize() {
  const cnamApiEnv = DmpConnect.isDevelopmentMode ? "dev" : "prod";

  const version = `v2 - ${cnamApiEnv}`;
  register("DMP API", version);
}

function register(name, version) {
  if (!libraries._getLibraryByName(name)) {
    libraries.register(name, version);
  }
}

export default {
  initialize
};
